import Vue from 'vue'
import Router from 'vue-router'
import Login from './pages/Login.vue'
import WebApp from './layouts/WebApp.vue'
import Register from './pages/Register.vue'
import ForgetPassword from './pages/ForgetPassword.vue'
import NotionAuth from './pages/NotionAuth.vue'
import Tray from './pages/Tray.vue'
import AlipaySubscription from './pages/AlipaySubscription'
import BindAccount from './pages/BindAccount'
import AppleLoginVue from './components/AppleLogin.vue'
import PinWindow from './pages/PinWindow.vue'

import store from '@/store'
Vue.use(Router)

let routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/mine',
    name: 'mine',
    component: WebApp,
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
  },
  {
    path: '/forgetpassword',
    name: 'forget',
    component: ForgetPassword,
  },
  {
    path: '/notion_auth',
    name: 'notion_auth',
    component: NotionAuth,
  },
  {
    path: '/alipay_subscription/:plan',
    name: 'alipay_subscription',
    component: AlipaySubscription,
  },
  {
    path: '/bind_account',
    name: 'bind_account',
    component: BindAccount,
  },
  {
    path: '/apple_login',
    name: 'apple_login',
    component: AppleLoginVue,
  },
]

if (process.env.IS_ELECTRON) {
  const appRoutes = [
    {
      path: '/tray',
      name: 'tray',
      component: Tray,
    },
    {
      path: '/pin_window/:slug',
      name: 'pin_window',
      component: PinWindow,
    },
  ]

  routes.push(...appRoutes)
}

const router = new Router({
  // mode: 'history',
  mode: process.env.IS_ELECTRON ? 'hash' : 'history',
  routes,
})

function handleRouteNavigation(to, from, next) {
  //const isAuthRoute = to.name === 'register' || to.name === 'login' || to.name === 'forget'
  //const userLoggedIn = store.state.me

  //if (userLoggedIn) {
  //  if (isAuthRoute) {
  //    next({ name: 'mine' })
  //  } else {
  //    next()
  //  }
  //} else {
  //  if (isAuthRoute) {
  //    next()
  //  } else {
  //    next({ name: 'login' })
  //  }
  //}
  if (to.name == 'register' || to.name == 'login') {
    if (store.state.me) {
      next({ name: 'mine' })
    } else {
      next()
    }
  }
  next()
}

router.beforeEach(handleRouteNavigation)

export default router
